<template>
    <div class="bgFoto">
        <div class="row justify-content-center einblenden1">
          <div class="col-md-8 text-center headline">
            <h1 class="headline">Ihr Partner für moderne Verpackungslösungen</h1>
          </div>
        </div>
        <div class="row justify-content-center einblenden1 pt-5">
          <div class="col-md-8 DES bildschirnansicht">
            <h2 class="headline2 p-4">
              Wir stehen für Qualität, Präzision und individuelle Lösungen.
            </h2>
            <h3 class="headline2 p-4">
              Verpackungen aus Wellpappe, Karton, Papier <br /><br />
              Verpackungszubehör wie Klebebänder, Stretchfolien, Polstermaterial und Paletten
            </h3>           
          </div>          
        </div>
      </div>
</template>